/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute, FormState, FormStateBuilder } from '@gh/common-shared';
import { DialogInput, EmptyDialogInput } from '@gh/core-ui';
import { JobCoDetailsQuoteFilter } from '../../../resources/job-co-details.model';

@Component({
  standalone: false,
  selector: 'gh-job-co-details-quote-filter-dialog',
  templateUrl: 'job-co-details-quote-filter-dialog.component.html',
  styleUrls: ['job-co-details-quote-filter-dialog.component.scss'],
})
export class JobCoDetailsQuoteFilterDialogComponent implements OnInit, DialogInput<EmptyDialogInput> {
  input: EmptyDialogInput;
  form: FormState<JobCoDetailsQuoteFilter>;

  constructor(private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder) {
  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      value: {
        price: true,
        quantity: true,
        units: true,
      },
      children: {
        price: void 0,
        quantity: void 0,
        units: void 0,
      },
    });
  }

  onApply(): void {
    this.dialogRef.close(this.form.submitValue);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}

export const jobCoDetailsQuoteFilterDialogRoute = createDialogRoute({
  component: JobCoDetailsQuoteFilterDialogComponent,
  config: { disableClose: true },
});
